<template>
  <div>
    <InvalidTestCodeDialog :invalidCodes="invalidCodes" :state="invalidDialog" @closeDialog="closeInvalid" />
    <v-dialog v-model="dialog" persistent max-width="620px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>RỌC MÃ PHÁCH</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <v-form v-bind="this.$attrs" ref="form">
            <v-row no-gutters>
              <v-col cols="12">
                <div class="d-flex">
                  Xin vui lòng điền tiền tố:
                  <v-text-field
                    class="mx-2"
                    v-model="prefix"
                    label="Tiền tố"
                    :rules="[rules.required]"
                    dense
                    outlined
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <div class="d-flex">
                  Xin vui lòng điền số bắt đầu:
                  <v-text-field
                    class="mx-2"
                    v-model="testIndex"
                    label="Số bắt đầu"
                    :rules="[$rules.number]"
                    dense
                    outlined
                  ></v-text-field>
                </div>
                <span>
                  <span style="color: red"
                    ><i><strong>(*) Lưu ý:</strong></i></span
                  >
                  Tiền tố phải có đủ 2 ký tự.
                </span>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="openConfirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDialog" persistent max-width="620px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>XÁC NHẬN THAO TÁC</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeConfirm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <p class="ma-0">
            <span style="color: red"
              ><strong><i>(*)Lưu ý: </i></strong></span
            >Thao tác này sẽ đánh lại mã phách của tất cả học sinh trong phòng và môn này.<br />
            Bạn có chắc là bạn muốn thực hiện thao tác không?
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="closeConfirm" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="confirm()">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { RoomSubject } from '../../plugins/api'
import InvalidTestCodeDialog from './InvalidTestCodeDialog.vue'
export default {
  props: {
    data: Object,
    state: Boolean
  },
  components: {
    InvalidTestCodeDialog
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
        this.progressDialog = false
      }
    },
    data: {
      immediate: true,
      handler(newVal) {
        this.setDefaultValues(newVal)
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      confirmDialog: false,
      prefix: '',
      testIndex: '',
      invalidCodes: '',
      invalidDialog: false,
      rules: {
        required: value => !!value || 'Phải nhập tiền tố',
        prefixLength: value => value.length === 2 || 'Tiền tố phải có đủ 2 ký tự.'
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('closeDialog')
    },
    openConfirm() {
      if (this.$refs.form.validate()) {
        this.confirmDialog = true
      }
    },
    closeConfirm() {
      this.confirmDialog = false
    },
    closeInvalid() {
      this.invalidDialog = false
      this.invalidCodes = ''
    },
    async confirm() {
      this.$loading.active = true
      const data = {
        id: this.data.id,
        prefix: this.prefix,
        testIndex: this.testIndex,
        room: this.data.room.id,
        subject: this.data.subject.id
      }
      const indexing = await RoomSubject.assignTestCode(data)
      if (indexing) {
        if (indexing.existedCode) {
          this.invalidCodes = indexing.existedCode
          this.invalidDialog = true
          this.closeConfirm()
          this.loading = false
        } else {
          this.$alert.success('Rọc mã phách thành công')
          this.$emit('refresh')
          this.closeConfirm()
          this.cancel()
        }
      } else {
        this.$alert.error('Lỗi rọc phách')
        this.closeConfirm()
      }
      this.$loading.active = false
    },
    setDefaultValues(data) {
      if (data) {
        this.prefix = data.prefix || ''
        this.testIndex = data.testIndex || ''
      }
    }
  }
}
</script>
